import { Badge } from "@/components/ui/badge";
import {
  computePlaneLabel,
  type I2VProviderSummary,
} from "../experiments/providerExperimentTypes";

export function H3LocalBadge({
  summary,
  compact = false,
}: {
  summary?: I2VProviderSummary | null;
  compact?: boolean;
}) {
  if (!summary?.has_h3) return null;
  const selected = summary.evidence === "selected_manifest";
  const h3 = summary.h3_scene_count ?? 0;
  const total = summary.generated_scene_count ?? 0;
  const fallbackOnly = selected && h3 === 0;
  const origin =
    summary.assignment?.scope === "customer"
      ? "Customer A/B"
      : summary.assignment?.scope === "launch"
        ? "Guaranteed launch"
        : summary.assignment?.scope === "internal"
          ? "Internal"
          : summary.assignment
            ? "Other route"
            : "Historical · assignment unknown";
  const detail = selected
    ? `${h3}/${total} generated clips use H3${fallbackOnly ? " · Fallback only" : ""} · ${computePlaneLabel(summary.compute_plane)}`
    : "Assigned · generation evidence pending";
  return (
    <span
      className="inline-flex flex-wrap items-center gap-1.5"
      title={`${origin} · ${detail}`}
    >
      <Badge
        variant="outline"
        className="border-violet-300 bg-violet-50 text-violet-800 dark:border-violet-700 dark:bg-violet-950 dark:text-violet-200"
      >
        {summary.compute_plane === "fal" ? "H3 · fal AI" : "H3"}
      </Badge>
      {!compact && (
        <span className="text-xs text-muted-foreground">{detail}</span>
      )}
    </span>
  );
}
